import {replaceCommas} from '../../utils/fields';

// prettier-ignore
export function recalculateValues(formTextValues, recommendedSleipnerTextValues){

	let formValues = replaceCommas(formTextValues);
	const recommendedSleipner = replaceCommas(recommendedSleipnerTextValues);

	let calculated = {};

	calculated["Multiplier for labour hour growth"] =
		formValues["estimatedMachineLifetime"] / recommendedSleipner["constantValueForEstimatedMachineLifetime"];

	calculated["Labour hours for undercarriage maintenance during lifetime"] =
		calculated["Multiplier for labour hour growth"] * recommendedSleipner["labourHoursForUndercarriageMaintenanceDuringLifetime"]

	calculated["Annual time spent travelling without Sleipner (h)"] =
	 	formValues["annualOperatingHours(h)"] * (formValues["tramming(%)"] / 100);

	 calculated["Annual time spent travelling with Sleipner (h)"] =
	 	calculated["Annual time spent travelling without Sleipner (h)"] * 0.4;

	 calculated["Annual time spent travelling with Sleipner (%)"] =
	 	(calculated["Annual time spent travelling with Sleipner (h)"] / formValues["annualOperatingHours(h)"]) * 100;

	calculated["Annual time spent travelling without Sleipner (%)"] =
		(calculated["Annual time spent travelling without Sleipner (h)"] / formValues["annualOperatingHours(h)"]) * 100;

	calculated["Annual time saved travelling with Sleipner (%)"] =
		calculated["Annual time spent travelling without Sleipner (%)"] - calculated["Annual time spent travelling with Sleipner (%)"];

	calculated["Annual saved travelling time (h)"] =
		calculated["Annual time spent travelling without Sleipner (h)"] - calculated["Annual time spent travelling with Sleipner (h)"];

	calculated["Utilization without Sleipner (%)"] =
		((formValues["annualOperatingHours(h)"] - calculated["Annual time spent travelling without Sleipner (h)"]) / formValues["annualOperatingHours(h)"]) * 100;

	calculated["Utilization with Sleipner (%)"] =
		((formValues["annualOperatingHours(h)"] - calculated["Annual time spent travelling with Sleipner (h)"]) / formValues["annualOperatingHours(h)"]) * 100;

	calculated["Annual increase in production (tonnes)"] =
		calculated["Annual saved travelling time (h)"] * formValues["production,(Tonnes/hour)"]

	calculated["Production increase ($)"] =
		calculated["Annual increase in production (tonnes)"] * formValues["revenuePerTonne($)"];

	calculated["Fuel saved with Sleipner in year (litres)"] =
		(recommendedSleipner["fuelConsumptionW/OSleipner(liters/hour)"] - recommendedSleipner["fuelConsumptionWSleipner(liters/hour)"]) * calculated["Annual saved travelling time (h)"];

	calculated["Fuel consumption without sleipner in year"] =
		recommendedSleipner["fuelConsumptionW/OSleipner(liters/hour)"] * recommendedSleipner["annualOperatingHours(h)"];

	calculated["Fuel consumption with sleipner in year"] =
		recommendedSleipner["fuelConsumptionWSleipner(liters/hour)"] * recommendedSleipner["annualOperatingHours(h)"];

	calculated["Fuel consumption without sleipner in time spent traveling"] =
		recommendedSleipner["fuelConsumptionW/OSleipner(liters/hour)"] * calculated["Annual time spent travelling without Sleipner (h)"];

	calculated["Fuel consumption with sleipner in time spent traveling"] =
		recommendedSleipner["fuelConsumptionWSleipner(liters/hour)"] * calculated["Annual time spent travelling with Sleipner (h)"];

	calculated["Fuel saved with Sleipner during lifetime (litres)"] =
		calculated["Fuel saved with Sleipner in year (litres)"] * (formValues["estimatedMachineLifetime"] / formValues["annualOperatingHours(h)"])

	calculated["Yearly fuel savings ($)"] =
		calculated["Fuel saved with Sleipner in year (litres)"] * formValues["averageFuelPrice($/l)"];

	 calculated["Lifetime fuel savings ($)"] =
	 	calculated["Fuel saved with Sleipner during lifetime (litres)"] * formValues["averageFuelPrice($/l)"];

	calculated["CO2 reduction with Sleipner in year (tonnes)"] =
		2.67 * calculated["Fuel saved with Sleipner in year (litres)"] / 1000;

	calculated["CO2 produced with Sleipner in year (tonnes)"] =
		calculated["Fuel consumption with sleipner in year"] * 2.67 / 1000;

	calculated["CO2 produced without Sleipner in year (tonnes)"] =
		calculated["Fuel consumption without sleipner in year"] * 2.67 / 1000;

	calculated["CO2 produced without Sleipner in time spent travelling (tonnes)"] =
		recommendedSleipner["fuelConsumptionW/OSleipner(liters/hour)"] * calculated["Annual time spent travelling without Sleipner (h)"] * 2.67 / 1000;

	calculated["CO2 produced with Sleipner in time spent travelling (tonnes)"] =
		recommendedSleipner["fuelConsumptionWSleipner(liters/hour)"] * calculated["Annual time spent travelling with Sleipner (h)"] * 2.67 / 1000;

	calculated["CO2 reduction with Sleipner in lifetime (tonnes)"] =
		2.67 * calculated["Fuel saved with Sleipner during lifetime (litres)"] / 1000;

	calculated["LCC cost reduction ($/h)"] =
		0.5 * recommendedSleipner["undercarriageCostPerHour($)(OnlyUndercarriageRelatedParts)"];

	calculated["LCC cost reduction (%)"] =
		(calculated["LCC cost reduction ($/h)"] / (recommendedSleipner["maintenanceCostPerHour($)(Parts+Fluids,ExcludingUndercarriageRelatedParts)"] + recommendedSleipner["undercarriageCostPerHour($)(OnlyUndercarriageRelatedParts)"] + recommendedSleipner['ownershipCosts'])) * 100;

	calculated["LCC cost reduction during lifetime ($)"] =
		calculated["LCC cost reduction ($/h)"] * formValues["estimatedMachineLifetime"]

	calculated["Undercarriage related labour hours saving during lifetime (h)"] =
		0.5 * calculated["Labour hours for undercarriage maintenance during lifetime"];

	calculated["Undercarriage related labour hours saving during lifetime ($)"] =
		calculated["Undercarriage related labour hours saving during lifetime (h)"] * formValues["labourCostPerHourForMaintenance"]

	calculated["Lifetime undercarriage rebuild part savings ($)"] =
		recommendedSleipner["undercarriageCostPerHour($)(OnlyUndercarriageRelatedParts)"] * formValues["estimatedMachineLifetime"] * 0.5

	calculated["Yearly Fuel savings"] = calculated["Yearly fuel savings ($)"];

	calculated["Increased tonnes per year"] = calculated["Annual increase in production (tonnes)"];

	calculated["Total Investment"] =
		recommendedSleipner["price"];

	calculated["Lifetime CO2 kilometers compared to low emission hybrid cars"] =
		(calculated["CO2 reduction with Sleipner in lifetime (tonnes)"] * 1000000) / 94

	calculated["The amount of times you can drive around the world"] =
		calculated["Lifetime CO2 kilometers compared to low emission hybrid cars"] / 40075;

	calculated["The amount of times to drive to moon and back"] =
		calculated["Lifetime CO2 kilometers compared to low emission hybrid cars"] / (384400 * 2)

	calculated["Times undercarriage needs change"] =
		formValues["estimatedMachineLifetime"] / formValues["undercarriageLifetime(h)"];

	calculated["Total ammount of undercarriage changes"] =
		Math.floor(calculated["Times undercarriage needs change"]);

	calculated["Undercarriage lifetime rebuild costs"] =
		recommendedSleipner["averageUndercarriageRebuildCost(€)(fullMidlifeRebuildIncl.Motors,FinalsRollers,SproketsEtc.)"] * calculated["Total ammount of undercarriage changes"];

	calculated["Lifetime undercarriage rebuild savings"] =
		calculated["Undercarriage lifetime rebuild costs"] / 2;

	calculated["Annual undercarriage rebuild part savings ($)"] =
		calculated["Lifetime undercarriage rebuild savings"] / (formValues["estimatedMachineLifetime"] / formValues["annualOperatingHours(h)"])

	calculated["Undercarriage yearly savings"] =
		(formValues["estimatedMachineLifetime"] / formValues["annualOperatingHours(h)"]) / calculated["Undercarriage related labour hours saving during lifetime ($)"] + calculated["Annual undercarriage rebuild part savings ($)"];

	calculated["Total savings"] = calculated["Yearly Fuel savings"] + calculated["Undercarriage yearly savings"];

	calculated["Investment payback time (month)"] =
		(calculated["Total Investment"] * 12) / calculated["Total savings"];

	let rounded = {};
	Object.keys(calculated).forEach((key) => {rounded[key] = Math.floor(calculated[key] * 100) / 100});

	return rounded;

}
